import * as Yup from 'yup';
export const validationsWeCallYou = Yup.object({
    type_identification: Yup.string().required(
        'El tipo de identificación es obligatorio'
    ),
    identification: Yup.string()
        .required('La identificación es obligatoria')
        .matches(
            /^(?:[0-9]{6,10}|[A-Z]{2}[0-9]{6}|[A-Z][0-9]{7})$/,
            'La identificacion debe ser valida'
        ),
    name: Yup.string()
        .required('El nombre es obligatorio')
        .matches(
            /^[A-Za-zÀ-ÖØ-öø-ÿ-' ]+$/,
            'El nombre solo puede contener letras'
        )
        .test(
            'NoNumbers',
            'El nombre no puede contener números',
            (value) => !/\d/.test(value)
        ),
    surname: Yup.string()
        .required('El apellido es obligatorio')
        .matches(
            /^[A-Za-zÀ-ÖØ-öø-ÿ-' ]+$/,
            'El apellido solo puede contener letras'
        )
        .test(
            'NoNumbers',
            'El apellido no puede contener números',
            (value) => !/\d/.test(value)
        ),
    email: Yup.string()
        .email('El correo es inválido')
        .required('El correo es obligatorio'),
    phone: Yup.string()
        .matches(
            /^(60[0-8]\d{7}|3\d{9})$/,
            'El numero de contacto no es valido'
        )
        .required('El número de celular es obligatorio'),
    acceptPolicy: Yup.boolean()
        .oneOf(
            [true],
            'Debe aceptar la política de privacidad y uso de datos personales'
        )
        .required(
            'Debe aceptar la política de privacidad y uso de datos personales'
        ),
});

export const initialValuesWeCallYou = {
    type_identification: '',
    identification: '',
    name: '',
    surname: '',
    email: '',
    phone: '',
    observation: '',
    acceptPolicy: false,
};
